export enum FormStage {
  Dates = 'assignment',
  Grouping = 'grouping',
  Grading = 'grading',
}
